export const HomepageNavigationIntent = {
  TravelOffersActivity: "travel_offers_activity",
  TravelOffersFaq: "travel_offers_faq",
  TravelProfileTravelers: "travel_profile_travelers",
  FlightsShopDeparture: "flights_shop_departure",
  PackagesSearch: "packages_search",
  PackagesHotelsAvailability: "packages_hotels_availability",
} as const;

export type HomepageNavigationIntent =
  (typeof HomepageNavigationIntent)[keyof typeof HomepageNavigationIntent];

export type ResolveHomepageNavigationIntentFn = (
  intent: string
) => string | undefined;
